import {
  Firmware,
  FirmwareQueryParam,
  FirmwareUploadParam,
} from "/@/types/device-firmware";
import request, {
  CommonListResponse,
  IListWorkspaceResponse,
  IPage,
  IWorkspaceResponse,
} from "/@/api/http/request";
import requestvedio from "/@/api/http/requestvedio";
import { Device } from "/@/types/device";

const HTTP_PREFIX = "/manage/api/v1";

// login
export interface LoginBody {
  username: string;
  password: string;
  flag: number;
  workspace?: string;
}
export interface BindBody {
  device_sn: string;
  user_id: string;
  workspace_id: string;
  domain?: string;
}
export interface HmsQueryBody {
  sns: string[];
  children_sn: string;
  device_sn: string;
  language: string;
  level: number | string;
  begin_time: number;
  end_time: number;
  message: string;
  domain: string | number;
}

// 获取账号工作单位列表
export const getWorkSpace = async function (
  body: LoginBody
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/getWorkSpace`;
  const result = await request.post(url, body);
  return result.data;
};
// 登录接口
export const login = async function (
  body: LoginBody
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/login`;
  const result = await request.post(url, body);
  return result.data;
};
// 是否有登录权限
export const loginFlag = async function (
  body: LoginBody
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/login1`;
  const result = await request.post(url, body);
  return result.data;
};
// 根据token获取用户信息
export const getInfoByToken = async function (
  body: any
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/users/getByToken`;
  const result = await request.post(url, body);
  return result.data;
};
// 短信登录
export const msgLoginApi = async function (
  body: any
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/loginVerificationNoPasswd`;
  const result = await request.post(url, body);
  return result.data;
};
// 通过用户名登录
export const loginByUser = async function (
  body: any
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/login2`;
  const result = await request.post(url, body);
  return result.data;
};
// 校验账号密码
export const loginByCheck = async function (
  body: any
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/login3`;
  const result = await request.post(url, body);
  return result.data;
};
// 发送验证码
export const loginByCode = async function (
  body: any
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/sendCode`;
  const result = await request.post(url, body);
  return result.data;
};
// 验证码登录
export const loginByVer = async function (
  body: any
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/loginVerification`;
  const result = await request.post(url, body);
  return result.data;
};
// 获取用户权限列表
export const getUserAuth = async function (id: any) {
  const url = `role/getAuthList?userId=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 用户登录名查找组织列表
export const getOrganization = async function (
  body: any
): Promise<IWorkspaceResponse<any>> {
  const url = `OrganizationUser/findByUserLogin?userName=${body.username}`;
  const result = await request.get(url);
  return result.data;
};
// 通过组织id查找项目
export const getOrgaProject = async function (
  body: any
): Promise<IWorkspaceResponse<any>> {
  const url = `OrganizationWorkspace/findByOrganizationId?organizationId=${body.organizationId}&type=${body.type}&join=${body.join}&sort=${body.sort}&userName=${body.userName}&projectName=${body.projectName}`;
  const result = await request.get(url);
  return result.data;
};

// 获取组织仪表盘数据
export const getOrganizationDashboard = async function (
  organizationId: number
): Promise<IWorkspaceResponse<any>> {
  const url = `Organization/count?id=${organizationId}`;
  const result = await request.get(url);
  return result.data;
};
// Refresh Token
export const refreshToken = async function (body: {}): Promise<
  IWorkspaceResponse<any>
> {
  const url = `${HTTP_PREFIX}/token/refresh`;
  const result = await request.post(url, body);
  return result.data;
};

// Get Platform Info
export const getPlatformInfo = async function (): Promise<
  IWorkspaceResponse<any>
> {
  const url = `${HTTP_PREFIX}/workspaces/current`;
  const result = await request.get(url);
  return result.data;
};

// Get User Info
export const getUserInfo = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/users/current`;
  const result = await request.get(url);
  return result.data;
};

// Get Device Topo
export const getDeviceTopo = async function (
  workspace_id: string
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices`;
  const result = await request.get(url);
  return result.data;
};

// Get Livestream Capacity
export const getLiveCapacity = async function (body: {}): Promise<
  IWorkspaceResponse<any>
> {
  const url = `${HTTP_PREFIX}/live/capacity`;
  const result = await request.get(url, body);
  return result.data;
};

// Start Livestream
export const startLivestream = async function (body: {}): Promise<
  IWorkspaceResponse<any>
> {
  const url = `${HTTP_PREFIX}/live/streams/start`;
  const result = await requestvedio.post(url, body);
  return result.data;
};

// Stop Livestream
export const stopLivestream = async function (body: {}): Promise<
  IWorkspaceResponse<any>
> {
  const url = `${HTTP_PREFIX}/live/streams/stop`;
  const result = await request.post(url, body);
  return result.data;
};
// Update Quality
export const setLivestreamQuality = async function (body: {}): Promise<
  IWorkspaceResponse<any>
> {
  const url = `${HTTP_PREFIX}/live/streams/update`;
  const result = await request.post(url, body);
  return result.data;
};

export const getAllUsersInfo = async function (
  wid: string,
  body: IPage,
  formState: any
): Promise<CommonListResponse<any>> {
  const url = `${HTTP_PREFIX}/users/${wid}/users?&page=${body.page}&page_size=${body.page_size}&keyWord=${formState.keyWord}`;
  const result = await request.get(url);
  return result.data;
};
// 删除用户
export const delUsersInfo = async function (
  wid: string,
  userId: any
): Promise<CommonListResponse<any>> {
  const url = `${HTTP_PREFIX}/users/${wid}/users/${userId}/delete`;
  const result = await request.get(url);
  return result.data;
};
// 新增用户
export const addUserInfo = async function (
  wid: string,
  body: any
): Promise<CommonListResponse<any>> {
  const url = `${HTTP_PREFIX}/users/${wid}/users/add`;
  const result = await request.post(url, body);
  return result.data;
};
// 修改用户
export const editUserInfo = async function (
  wid: string,
  body: any,
  userId: any
): Promise<CommonListResponse<any>> {
  const url = `${HTTP_PREFIX}/users/${wid}/users/${userId}`;
  const result = await request.put(url, body);
  return result.data;
};
// 获取工作区间
export const getStatusList = async function (): Promise<
  CommonListResponse<any>
> {
  const url = `${HTTP_PREFIX}/workspaces/list`;
  const result = await request.get(url);
  return result.data;
};
export const updateUserInfo = async function (
  wid: string,
  user_id: string,
  body: {}
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/users/${wid}/users/${user_id}`;
  const result = await request.put(url, body);
  return result.data;
};

export const bindDevice = async function (
  body: BindBody
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${body.device_sn}/binding`;
  const result = await request.post(url, body);
  return result.data;
};

export const unbindDevice = async function (
  device_sn: string
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${device_sn}/unbinding`;
  const result = await request.delete(url);
  return result.data;
};

export const getDeviceBySn = async function (
  workspace_id: string,
  device_sn: string
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/${device_sn}`;
  const result = await request.get(url);
  return result.data;
};

/**
 * 获取绑定设备信息
 * @param workspace_id
 * @param body
 * @param domain
 * @returns
 */
export const getBindingDevices = async function (
  workspace_id: string,
  body: IPage,
  domain: string,
  formState: any
): Promise<IListWorkspaceResponse<Device>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/bound?&page=${body.page}&page_size=${body.page_size}&domain=${domain}&keyWord=${formState.keyWord}`;
  const result = await request.get(url);
  return result.data;
};
// 获取其他设备信息
export const getOtherDevices = async function (
  workspace_id: string,
  body: IPage,
  formState: any
) {
  let type = formState?.type ? formState.type : "";
  const url = `/lxEquipment/list?&page=${body.page}&page_size=${body.page_size}&keyWord=${formState.keyWord}&workspace=${workspace_id}&type=${type}`;
  const result = await request.get(url);
  return result.data;
};
// 删除其他设备信息
export const delOtherDevices = async function (id: any) {
  const url = `/lxEquipment/delete?&id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 修改其他设备信息
export const editOtherDevices = async function (body: {}) {
  const url = `lxEquipment/update`;
  const result = await request.post(url, body);
  return result.data;
};
// 报存其他设备信息
export const saveOtherDevices = async function (body: {}) {
  const url = `lxEquipment/save`;
  const result = await request.post(url, body);
  return result.data;
};
export const updateDevice = async function (
  body: {},
  workspace_id: string,
  device_sn: string
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/${device_sn}`;
  const result = await request.put(url, body);
  return result.data;
};

export const getUnreadDeviceHms = async function (
  workspace_id: string,
  device_sn: string
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/hms/${device_sn}`;
  const result = await request.get(url);
  return result.data;
};

export const updateDeviceHms = async function (
  workspace_id: string,
  device_sn: string
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/hms/${device_sn}`;
  const result = await request.put(url);
  return result.data;
};

export const getDeviceHms = async function (
  body: HmsQueryBody,
  workspace_id: string,
  pagination: IPage
): Promise<IListWorkspaceResponse<any>> {
  let url =
    `${HTTP_PREFIX}/devices/${workspace_id}/devices/hms?page=${pagination.page}&page_size=${pagination.page_size}` +
    `&level=${body.level ?? ""}&begin_time=${body.begin_time ?? ""}&end_time=${
      body.end_time ?? ""
    }&message=${body.message ?? ""}&language=${body.language}`;
  body.sns.forEach((sn: string) => {
    if (sn !== "") {
      url = url.concat(`&device_sn=${sn}`);
    }
  });
  const result = await request.get(url);
  return result.data;
};

export const changeLivestreamLens = async function (body: {}): Promise<
  IWorkspaceResponse<any>
> {
  const url = `${HTTP_PREFIX}/live/streams/switch`;
  const result = await request.post(url, body);
  return result.data;
};

export const getFirmwares = async function (
  workspace_id: string,
  page: IPage,
  body: FirmwareQueryParam
): Promise<IListWorkspaceResponse<Firmware>> {
  const device_name = body.device_name || ''
  const url =
    `${HTTP_PREFIX}/workspaces/${workspace_id}/firmwares?page=${page.page}&page_size=${page.page_size}` +
    `&device_name=${device_name}&product_version=${
      body.product_version
    }&status=${body.firmware_status ?? ""}`;
  const result = await request.get(url);
  return result.data;
};

export const importFirmareFile = async function (
  workspaceId: string,
  param: FormData
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/firmwares/file/upload`;
  const result = await request.post(url, param);
  return result.data;
};

export const changeFirmareStatus = async function (
  workspaceId: string,
  firmwareId: string,
  param: { status: boolean }
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/firmwares/${firmwareId}`;
  const result = await request.put(url, param);
  return result.data;
};
// 绑定视频
export const getVedioList = async function (
  sn: string
): Promise<IListWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/live/capacityBySn1?sn=${sn}`;
  const result = await request.get(url);
  return result.data;
};
// 获取数据
export const getOtherDeviceInfo = async function (sn: string) {
  // /lxAirData/real/time/monitoring?deviceSn=4TADKCF001002W
  const url = `/lxAirData/real/time/monitoring?deviceSn=${sn}`;
  const result = await request.get(url);
  return result.data;
};
// 获取折线数据
export const getTrendInfo = async function (page: number) {
  const url = `/lxAirData/list?page=${page}&page_size=1800`;
  const result = await request.get(url);
  return result.data;
};
// 获取角色列表
export const getRolesList = async function (body: {}) {
  const url = `role/list`;
  const result = await request.post(url, body);
  return result.data;
};
// 新增 角色
export const rolesAddApi = async function (body: any) {
  const url = `role/add`;
  const result = await request.post(url, body);
  return result.data;
};
// 修改 角色
export const rolesEditApi = async function (body: any) {
  const url = `role/edit`;
  const result = await request.post(url, body);
  return result.data;
};
// 删除 角色列表
export const rolesDel = async function (id: any) {
  const url = `role/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 获取所有权限
export const getAuthListAll = async function () {
  const url = `role/getAuthListAll`;
  const result = await request.get(url);
  return result.data;
};
// 根据角色id获取角色信息
export const getOneInfoApi = async function (id: any) {
  const url = `role/selectOne?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 获取工作单位列表
export const getWorkListApi = async function (body: {}) {
  const url = `workspaces/list`;
  const result = await request.post(url, body);
  return result.data;
};
// 删除 工作单位列表
export const workDelApi = async function (id: any) {
  const url = `workspaces/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 新增 工作单位
export const workAddApi = async function (body: any) {
  const url = `workspaces/add`;
  const result = await request.post(url, body);
  return result.data;
};
// 修改 工作单位
export const workEditApi = async function (body: any) {
  const url = `workspaces/edit`;
  const result = await request.post(url, body);
  return result.data;
};
// 根据工作单位id获取信息
export const getOneInfoWorkApi = async function (id: any) {
  const url = `workspaces/selectOne?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 获取视频配置分页查询
export const getVedioSysApi = async function (
  workspace_id: string,
  page: any,
  keyWords: any
) {
  const url = `gb28181/rtmpList?keyWords=${keyWords}&page=${page.page}&page_size=${page.page_size}&workspace=${workspace_id}`;
  const result = await request.get(url);
  return result.data;
};
// 删除 视频配置文件
export const delVedioApi = async function (id: any) {
  const url = `gb28181/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 控制大屏保存配置
export const saveConScreenApi = async function (body: any) {
  const url = `userVideo/saveOrUpdateConfig`;
  const result = await request.post(url, body);
  return result.data;
};
// 控制大屏 加载
export const resConScreenApi = async function (userId: any, isLsd = 0) {
  const url = `userVideo/getByUserId?userId=${userId}&isLsd=${isLsd}`;
  const result = await request.get(url);
  return result.data;
};
// 控制大屏获取视频列表
export const getVedioConApi = async function (
  workspace_id: string,
  page: IPage,
  keyWords: any
) {
  const url = `gb28181/rtmpListLargeScreen?keyWords=${keyWords}&page=${page.page}&page_size=${page.page_size}&workspace=${workspace_id}`;
  const result = await request.get(url);
  return result.data;
};
// 获取所有成员列表
export const getAllMenber = async function (
  workspace_id: string,
  keyWords: any
) {
  const url = `workspaces/userWorkspace?search=${keyWords}&workspace=${workspace_id}`;
  const result = await request.get(url);
  return result.data;
};
// 新增项目，用户关联项目
export const addProject = async function (body: any) {
  const url = `workspaces/userAddWorkspace`;
  const result = await request.post(url, body);
  return result.data;
};
// 编辑项目
export const editProject = async function (body: any) {
  const url = `workspaces/userDeleteAndAddWorkspace`;
  const result = await request.post(url, body);
  return result.data;
};
// 项目归档
export const editProjectfile = async function (body: any) {
  const url = `workspaces/edit`;
  const result = await request.post(url, body);
  return result.data;
};
// 组织列表
export const organizePage = async function (body: any) {
  const url = `Organization/page?current=${body.current}&size=${body.size}&organization_name=${body.organization_name}&organization_code=${body.organization_code}&username=${body.username}`;
  const result = await request.get(url);
  return result.data;
};
// 新增 组织
export const organAddApi = async function (body: any) {
  const url = `Organization/save`;
  const result = await request.post(url, body);
  return result.data;
};
// 修改 组织
export const organUpdateApi = async function (body: any) {
  const url = `Organization/update`;
  const result = await request.post(url, body);
  return result.data;
};
// 退出 组织
export const organExitApi = async function (id: number) {
  const url = `Organization/exit?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 获取 组织 权限
export const getOrganAuthApi = async function (params: any) {
  const url = `/role/getOrganizationAuthList?organizationId=${params.organizationId}&userId=${params.userId}`;
  const result = await request.get(url);
  return result.data;
};
// 获取 大屏 H5自定义列表
export const getH5ListApi = async function (params: any) {
  const url = `h5Config/pageMyWorkspace?h5name=${params.h5name}&sn=${params.sn}`;
  const result = await request.get(url);
  return result.data;
};
// 获取 大屏 空气 h5数据列表
export const getH5AirListApi = async function (sn: any, task: boolean) {
  const url = `gridding/list/data/sn?sn=${sn}&task=${task}`;
  const result = await request.get(url);
  return result.data;
};
// 获取 工地 列表
export const getBuildListApi = async function (param: any) {
  const land =
    param?.land_attribute || param?.land_attribute === 0
      ? param?.land_attribute
      : "";
  const url = `ConstructionSite/page?current=${param.current}&size=${param.size}&prs_name=${param.prs_name}&supervision=${param.supervision}&street=${param.street}&land_attribute=${land}`;
  const result = await request.get(url);
  return result.data;
};
// 删除 工地 列表
export const delBuildListApi = async function (id: any) {
  const url = `ConstructionSite/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 新增 工地 列表
export const addBuildListApi = async function (body: any) {
  const url = `ConstructionSite/save`;
  const result = await request.post(url, body);
  return result.data;
};
// 修改 工地 列表
export const updateBuildListApi = async function (body: any) {
  const url = `ConstructionSite/update`;
  const result = await request.post(url, body);
  return result.data;
};
// 坐标获取地址
export const buildAddressApi = async function (params: any) {
  const url = `receivingaAlarm/getAddressByZB?lon=${params.lng}&lat=${params.lat}`;
  const result = await request.get(url);
  return result.data;
};
// 地址输入获取坐标
export const buildLngApi = async function (address: any) {
  const url = `receivingaAlarm/getLngAndLatByAddr?address=${address}`;
  const result = await request.get(url);
  return result.data;
};
// 新增 视频配置
export const rtmpAddApi = async function (body: any) {
  const url = `/gb28181/add`;
  const result = await request.post(url, body);
  return result.data;
};
// 修改 视频配置
export const rtmpEditApi = async function (body: any) {
  const url = `/gb28181/update`;
  const result = await request.post(url, body);
  return result.data;
};
// 烟火识别列表
export const fireworksListApi = async function (params: any) {
  const url = `/fireworks/page?current=${params.page_num}&size=${params.page_size}&gbid=${params.gbid}&is_fireworks=${params.is_fireworks}&audit=${params.audit}`;
  const result = await request.get(url);
  return result.data;
};

// 人脸信息列表
export const faceInfoListApi = async function (params: any) {
  const url = `/face/page?current=${params.current}&size=${params.size}&name=${params.name}`;
  const result = await request.get(url);
  return result.data;
};
// 删除人脸信息
export const faceInfoDelApi = async function (id: number) {
  const url = `face/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 录入人脸图片
export const faceImageApi = async function (body: any) {
  const url = `/rzwxfile/upload/face`;
  const result = await request.post(url, body);
  return result.data;
};
// 录入人脸信息
export const faceInfoAddApi = async function (body: any) {
  const url = `face/save`;
  const result = await request.post(url, body);
  return result.data;
};
// 修改人脸信息
export const faceInfoUpdateApi = async function (body: any) {
  const url = `face/update`;
  const result = await request.post(url, body);
  return result.data;
};
// 人脸识别记录列表
export const faceLogListApi = async function (params: any) {
  const url = `face/log/page?current=${params.current}&size=${params.size}&name=${params.name}`;
  const result = await request.get(url);
  return result.data;
};
// 人脸识别记录 删除
export const faceLogDelApi = async function (id: number) {
  const url = `face/log/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 人形识别记录列表
export const humanLogListApi = async function (params: any) {
  const url = `body/log/page?current=${params.current}&size=${params.size}&gbid=${params.gbid}`;
  const result = await request.get(url);
  return result.data;
};
// 人形识别记录 删除
export const humanLogDelApi = async function (id: number) {
  const url = `body/log/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 分享按钮
export const shareInfoApi = async function (sn: string) {
  const url = `/live/share/share?gbid=${sn}`;
  const result = await request.get(url);
  return result.data;
};
// 开启、关闭分享
export const shareSwitchApi = async function (gbid: string, switches: number) {
  const url = `/live/share/switches?gbid=${gbid}&switches=${switches}`;
  const result = await request.get(url);
  return result.data;
};
// 开启、分享密码修改
export const sharePwdApi = async function (
  id: string,
  isPwd: number,
  pwd: string
) {
  const url = `/live/share/updatePwd?id=${id}&isPwd=${isPwd}&pwd=${pwd}`;
  const result = await request.get(url);
  return result.data;
};
// 分享天数修改
export const shareDayApi = async function (body: any) {
  const url = `/live/share/updateDay`;
  const result = await request.post(url, body);
  return result.data;
};
// 开启直播
export const shareStartApi = async function (key: any, pwd: string) {
  const url = `/live/share/start?key=${key}&pwd=${pwd}`;
  const result = await request.get(url);
  return result.data;
};
// 喊话内容列表
export const shoutListApi = async function (params: any) {
  const url = `megaphone/page?current=${params.current}&size=${params.size}&name=${params.name}&type=${params.type}`;
  const result = await request.get(url);
  return result.data;
};
// 删除喊话内容
export const shoutDelApi = async function (id: any) {
  const url = `megaphone/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 喊话
export const shouPlayApi = async function (id: any, sn: any, yl: any) {
  let yls = yl ? yl : "";
  const url = `megaphone/play?id=${id}&sn=${sn}&yl=${yls}`;
  const result = await request.get(url);
  return result.data;
};
// 喊话 御4
export const shouPlay2Api = async function (id: any, sn: any, yl = 100) {
  const url = `remote/play?id=${id}&sn=${sn}&yl=${yl}`;
  const result = await request.get(url);
  return result.data;
};
// 喊话 音量 御4
export const shouVolume2PlayApi = async function (yl: any, sn: any) {
  const url = `remote/playYLV2?sn=${sn}&yl=${yl}`;
  const result = await request.get(url);
  return result.data;
};
// 喊话 音量 御4 循环喊话
export const setShout2Api = async function (mode: any, sn: any) {
  const url = `remote/play/set?mode=${mode}&sn=${sn}`;
  const result = await request.get(url);
  return result.data;
};
// 喊话 音量 御4 循环喊话 停止
export const stopShout2Api = async function (sn: any) {
  const url = `remote/stop?sn=${sn}`;
  const result = await request.get(url);
  return result.data;
};
// 喊话 音量
export const shouVolumePlayApi = async function (yl: any, sn: any) {
  const url = `remote/playYL?sn=${sn}&yl=${yl}`;
  const result = await request.get(url);
  return result.data;
};
// 播放模式 喊话
export const setShoutApi = async function (mode: any, sn: any) {
  const url = `megaphone/play/set?mode=${mode}&sn=${sn}`;
  const result = await request.get(url);
  return result.data;
};
// 停止喊话
export const stopShoutApi = async function (sn: any) {
  const url = `megaphone/stop?sn=${sn}`;
  const result = await request.get(url);
  return result.data;
};
// 语音base64
export const shoutBaseApi = async function (body: any) {
  const url = `/megaphone/save/base64`;
  const result = await request.post(url, body);
  return result.data;
};
// 新增喊话内容
export const shoutSaveApi = async function (body: any) {
  const url = `/megaphone/save`;
  const result = await request.post(url, body);
  return result.data;
};
// 修改喊话内容
export const shoutUpdateApi = async function (body: any) {
  const url = `/megaphone/update`;
  const result = await request.post(url, body);
  return result.data;
};
// 上传喊话音频
export const propagandaApi = async function (body: any) {
  const url = `/rzwxfile/upload/propaganda`;
  const result = await request.post(url, body);
  return result.data;
};
// 新增任务接口
export const saveJobApi = async function (body: any) {
  const url = `/workspaces/saveJob`;
  const result = await request.post(url, body);
  return result.data;
};
// 进入智能环绕
export const enterSurroundApi = async function (params: any) {
  const url = `/drc/pioEnter?dockSn=${params.dockSn}&latitude=${params.latitude}&longitude=${params.longitude}&height=${params.height}`;
  const result = await request.get(url);
  return result.data;
};
// 退出智能环绕
export const exitSurroundApi = async function (dockSn: any) {
  const url = `/drc/pioExit?dockSn=${dockSn}`;
  const result = await request.get(url);
  return result.data;
};
// 飞行控制—POI 环绕速度设置
export const pioSpeedApi = async function (params: any) {
  const url = `/drc/pioSpeed?dockSn=${params.dockSn}&speed=${params.speed}`;
  const result = await request.get(url);
  return result.data;
};
// 红外测温模式设置
export const meteringSetApi = async function (param: any) {
  const url = `drc/meteringSet?dockSn=${param.dockSn}&index=${param.index}&mode=${param.mode}`;
  const result = await request.get(url);
  return result.data;
};
// 红外测温点设置
export const meteringPointSetApi = async function (param: any) {
  const url = `drc/meteringPointSet?dockSn=${param.dockSn}&index=${param.index}&x=${param.x}&y=${param.y}`;
  const result = await request.get(url);
  return result.data;
};
// 红外测温区域设置
export const meteringAreaSetApi = async function (param: any) {
  const url = `drc/meteringAreaSet?dockSn=${param.dockSn}&index=${param.index}&x=${param.x}&y=${param.y}&width=${param.width}&height=${param.height}`;
  const result = await request.get(url);
  return result.data;
};
// 机场试飞
export const testFlightApi = async function (sn: any) {
  const url = `receivingaAlarm/testFlight?sn=${sn}`;
  const result = await request.get(url);
  return result.data;
};
// 分屏 红外 视频
export const splitVedioApi = async function (params: any) {
  const url = `drc/split?dockSn=${params.dockSn}&enable=${params.enable}&index=${params.index}`;
  const result = await request.get(url);
  return result.data;
};
// 红外调色盘 红外 视频
export const paletteApi = async function (params: any) {
  const url = `drc/palette?dockSn=${params.dockSn}&style=${params.style}&index=${params.index}`;
  const result = await request.get(url);
  return result.data;
};
// 机场静音模式
export const silentModeApi = async function (params: any) {
  const url = `drc/silentMode?dockSn=${params.dockSn}&mode=${params.mode}`;
  const result = await request.get(url);
  return result.data;
};
// 车辆位置
export const carLocationApi = async function () {
  const url = `/car/location`;
  const result = await request.get(url);
  return result.data;
};
// 数据字典
export const dictionariesApi = async function (params: any) {
  const url = `Dictionaries/page?faId=${params.faId}&current=${params.current}&size=${params.size}`;
  const result = await request.get(url);
  return result.data;
};
// 数据字典 新增
export const dictionariesSaveApi = async function (params: any) {
  const url = `Dictionaries/save`;
  const result = await request.post(url, params);
  return result.data;
};
// 数据字典 修改
export const dictionariesUpdateApi = async function (params: any) {
  const url = `Dictionaries/update`;
  const result = await request.post(url, params);
  return result.data;
};
// 数据字典 删除
export const dictionariesDelApi = async function (id: any) {
  const url = `Dictionaries/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 机器狗 手动控制
export const dogControlApi = async function (params: any) {
  const url = `Dog/control?vx=${params.vx}&vy=${params.vy}&vyaw=${params.vyaw}`;
  const result = await request.get(url);
  return result.data;
};
// 模型管理列表
export const getModelListApi = async function (params: any) {
  const url = `/Model3d/page?current=${params.page_num}&size=${params.page_size}&modelName=${params.modelName}&workspaceId=${params.workspaceId}`;
  const result = await request.get(url);
  return result.data;
};
// 删除 模型管理
export const delModelListApi = async function (id: any) {
  const url = `/Model3d/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 导入 模型管理
export const addModelListApi = async function (body: any) {
  const url = `/Model3d/save`;
  const result = await request.post(url, body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return result.data;
};
// 修改模型状态
export const editModelListApi = async function (body: any) {
  const url = `/Model3d/update`;
  const result = await request.post(url, body);
  return result.data;
};
// 上传二进制文件转为url地址
export const getFileUrlApi = async function (params: any) {
  const url = `upload`;
  const result = await request.post(url, params);
  return result.data;
};
// 智图列表
export const getWisdomMapListApi = async function (params: any) {
  const url = `WisdomMap/page?workspaceId=${params.workspaceId}&current=${params.current}&size=${params.size}`;
  const result = await request.get(url);
  return result.data;
};
// 删除 智图列表
export const delWisdomMapApi = async function (id: any) {
  const url = `WisdomMap/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 下载 智图列表
export const downloadWisdomMapApi = async function (id: any) {
  const url = `WisdomMap/download?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 修改 智图列表
export const editWisdomMapApi = async function (data: any) {
  const url = `WisdomMap/update`;
  const result = await request.post(url, data);
  return result.data;
};
// 新增 智图列表
export const saveWisdomMapApi = async function (data: any) {
  const url = `WisdomMap/save`;
  const result = await request.post(url, data);
  return result.data;
};
// 新增 3d重建任务
export const saveModel3dJobApi = async function (data: any) {
  const url = `Model3d/job`;
  const result = await request.post(url, data);
  return result.data;
};
// 眼镜列表
export const getGlassesApi = async function (params: any) {
  const url = `Glasses/page?current=${params.current}&size=${params.size}&workspaceId=${params.workspaceId}&sn=${params.sn}&name=${params.name}`;
  const result = await request.get(url);
  return result.data;
};
// 推送 眼镜视频
export const putGlassesApi = async function (params: any) {
  const url = `Glasses/put?sn=${params.sn}&url=${params.url}`;
  const result = await request.get(url);
  return result.data;
};
// 获取航点喊话内容
export const getCourseCalloutApi = async function (sn: any) {
  const url = `CourseCallout/findBySn?sn=${sn}`;
  const result = await request.get(url);
  return result.data;
};
// 设置航点喊话内容
export const setCourseCalloutApi = async function (data: any) {
  const url = `CourseCallout/update`;
  const result = await request.post(url, data);
  return result.data;
};
// 导入 ai智能识别
export const addAiListApi1 = async function (body: any) {
  const url = `/AiLog/save1`;
  const result = await request.post(url, body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return result.data;
};
// ai智能识别列表
export const getAiListApi = async function (params: any) {
  const url = `/AiLog/page?current=${params.page_num}&size=${params.page_size}&aiType=${params.aiType}&workspaceId=${params.workspaceId}`;
  const result = await request.get(url);
  return result.data;
};
// 删除 ai智能识别
export const delAiListApi = async function (id: any) {
  const url = `/AiLog/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 河长 ai识别列表
export const getRiverAiApi = async function (workspaceId: string, params: any) {
  const url = `/RiverAi/page?current=${params.current}&size=${params.size}&aiStatus=${params.aiStatus}&typeId=${params.typeId}&workspaceId=${workspaceId}&isExist=${params.isExist}`;
  const result = await request.get(url);
  return result.data;
};
// 删除 河长ai识别列表
export const delRiverAiApi = async function (id: any) {
  const url = `/RiverAi/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 新增 河长ai识别
export const addAiImgLogApi = async function (data: any) {
  const url = `/RiverAi/photo/ai`;
  const result = await request.post(url, data);
  return result.data;
};
// 播放rtmp视频
export const startLivestreamRtmp = async function (
  stream: string
): Promise<IWorkspaceResponse<any>> {
  const url = `/DeviceChannel/startRtmp?stream=${stream}`;
  const result = await request.get(url);
  return result.data;
};
// 烟火识别 再次识别
export const resetFireworksApi = async function (id: any) {
  const url = `fireworks/tautology?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 烟火识别 删除
export const deleteFireworksApi = async function (id: any) {
  const url = `fireworks/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 设置探照灯
export const setLampModeApi = async function (sn: any, mode: any) {
  const url = `megaphone/drc_light_mode_set?sn=${sn}&mode=${mode}`;
  const result = await request.get(url);
  return result.data;
};
// 大屏 -- 接口--开始
// 近七天任务完成统计
export const getTask7Api = async function (workspace: any) {
  const url = `lsd/job/success/day7?workspace=${workspace}`;
  const result = await request.get(url);
  return result.data;
};
// 近七天机场任务完成统计
export const getTaskDock7Api = async function (workspace: any) {
  const url = `lsd/job/air/day7?workspace=${workspace}`;
  const result = await request.get(url);
  return result.data;
};
// 近七天时间段任务统计
export const getTaskTime7Api = async function (workspace: any) {
  const url = `lsd/job/time/day7?workspace=${workspace}`;
  const result = await request.get(url);
  return result.data;
};
// 今日飞行任务统计
export const getToadyTotalApi = async function (workspace: any) {
  const url = `lsd/job/today?workspace=${workspace}`;
  const result = await request.get(url);
  return result.data;
};
// 今日成果统计
export const getToadyFileApi = async function (workspace: any) {
  const url = `lsd/file/today?workspace=${workspace}`;
  const result = await request.get(url);
  return result.data;
};
// 一键标定
export const setRtkApi = async function (params: any) {
  const url = `drc/rtk/calibration?dockSn=${params.sn}&longitude=${params.lng}&latitude=${params.lat}&height=${params.height}`;
  const result = await request.get(url);
  return result.data;
};
// 获取 温度告警 列表
export const getTempWarnApi = async function (params: any) {
  const url = `TemperatureWarning/page?current=${params.current}&size=${params.size}&workspace=${params.workspace}&dockSn=${params.dockSn}&startTime=${params.startTime}&endTime=${params.endTime}`;
  const result = await request.get(url);
  return result.data;
};
// 获取视频配置 机场分类
export const getVedioDockApi = async function (workspace_id: string) {
  const url = `gb28181/rtmpList/dock?workspace=${workspace_id}`;
  const result = await request.get(url);
  return result.data;
};
// 单点登录 通过code登录
export const loginByCodeApi = async function (code: string) {
  const url = `manage/api/v1/sso?code=${code}`;
  const result = await request.get(url);
  return result.data;
};
// 通过手机号获取验证码
export const msgByCodeApi = async function (params: any) {
  const url = `manage/api/v1/sso11?code=${params.phone}`;
  const result = await request.get(url);
  return result.data;
};
// 告警事件删除
export const delWarnEventApi = async function (id: any) {
  const url = `JobTask/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// ai 工厂新增
export const addAiFactoryApi = async function (data: any) {
  const url = `AiFactory/save`;
  const result = await request.post(url, data);
  return result.data;
};
// ai工厂 列表 接口
export const getAiFactoryListApi = async function (params: any) {
  const url = `AiFactory/page?current=${params.current}&size=${params.size}&workspace=${params.workspace}`;
  const result = await request.get(url);
  return result.data;
};
// ai工厂 删除 接口
export const delAiFactoryApi = async function (id: any) {
  const url = `AiFactory/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 分页查询 自定义飞行区域
export const getFlyAreaApi = async function (params: any) {
  const url = `FlyArea/page?current=${params.current}&size=${params.size}&workspace=${params.workspace}`;
  const result = await request.get(url);
  return result.data;
};
// 新增 自定义飞行区域
export const addFlyAreaApi = async function (params: any) {
  const url = `FlyArea/save`;
  const result = await request.post(url, params);
  return result.data;
};
// 修改 自定义飞行区域
export const editFlyAreaApi = async function (params: any) {
  const url = `FlyArea/update`;
  const result = await request.post(url, params);
  return result.data;
};
// 删除 自定义飞行区域
export const delFlyAreaApi = async function (id: any) {
  const url = `FlyArea/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 分页查询 时空gis
export const getGisAreaApi = async function (params: any) {
  let areaName = params.areaName ? params.areaName : "";
  let areaStatus = params.areaStatus ? params.areaStatus : "";
  let repetition = params.repetition ? params.repetition : "";
  const url = `GisMap/page?current=${params.current}&size=${params.size}&workspace=${params.workspace}&areaName=${areaName}&areaType=&areaStatus=${areaStatus}&repetition=${repetition}`;
  const result = await request.get(url);
  return result.data;
};
// 新增 时空gis
export const addGisAreaApi = async function (params: any) {
  const url = `GisMap/save`;
  const result = await request.post(url, params);
  return result.data;
};
// 修改 时空gis
export const editGisAreaApi = async function (params: any) {
  const url = `GisMap/update`;
  const result = await request.post(url, params);
  return result.data;
};
// 删除 时空gis
export const delGisAreaApi = async function (id: any) {
  const url = `GisMap/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 设备同步 自定义飞行区域
export const sendFlyAreaApi = async function (params: any) {
  const url = `FlyArea/send?workspace=${params.workspace}&sn=${params.sn}`;
  const result = await request.get(url);
  return result.data;
};
// 设备 解除绑定
export const unBindingDockApi = async function (sn: any) {
  const url = `/manage/api/v1/devices/${sn}/unbinding`;
  const result = await request.get(url);
  return result.data;
};
// 设备操作 强制关闭
export const forceCloseApi = async function (sn: any) {
  const url = `/remote/cover_force_close/${sn}`;
  const result = await request.get(url);
  return result.data;
};
// 基桩管理 获取列表数据
export const getFoundationListApi = async function (page: any) {
  const url = `Foundation/page?current=${page.page}&size=${page.page_size}`;
  const result = await request.get(url);
  return result.data;
};
// 获取 注册码 code
export const getRegistcode = async function (): Promise<
  IWorkspaceResponse<any>
> {
  const url = `/machineIdentifier/getMachineCode`;
  const result = await request.get(url);
  return result.data;
};
// 注册 注册码 code
export const setRegistcode = async function (
  body: any
): Promise<IWorkspaceResponse<any>> {
  const url = `/machineIdentifier/registration?code=${body.code}`;
  const result = await request.get(url);
  return result.data;
};
// 离线视频ai管理
export const getOutVedioListApi = async function (body: any) {
  const url = `/OfflineVideoTask/getAll?current=${body.current}&size=${body.size}&type=${body.type}`;
  const result = await request.get(url);
  return result.data;
};
// 离线视频ai管理 详情
export const getOutVedioOneApi = async function (id: any) {
  const url = `/OfflineVideoTask/getOne?video_id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 设置空中回传
export const setAirImgApi = async function (params: any) {
  const url = `/drc/property/set?dockSn=${params.dockSn}&key=air_transfer_enable&b=${params.b}`;
  const result = await request.get(url);
  return result.data;
};
// 获取 空中回传
export const getAirImgApi = async function (params: any) {
  const url = `/device/getBySn?sn=${params.dockSn}`;
  const result = await request.get(url);
  return result.data;
};
// 获取 ai短信推送
export const getAiSmsConfigApi = async function (params: any) {
  const url = `/AiSmsConfig/page?sn=${params.sn}&current=${params.current}&size=${params.size}&workspace=${params.workspace}&phone=${params.phone}&type=${params.type}`;
  const result = await request.get(url);
  return result.data;
};
// 删除 ai短信推送
export const delAiSmsConfigApi = async function (id: any) {
  const url = `/AiSmsConfig/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 新增 ai短信推送
export const saveAiSmsConfigApi = async function (data: any) {
  const url = `/AiSmsConfig/save`;
  const result = await request.post(url, data);
  return result.data;
};
// 修改 ai短信推送
export const editAiSmsConfigApi = async function (data: any) {
  const url = `/AiSmsConfig/update`;
  const result = await request.post(url, data);
  return result.data;
};
// 获取 ai配置
export const getAiConfigApi = async function (params: any) {
  const url = `/AiConfig/page?conf_name=${params.confName}&current=${params.current}&size=${params.size}&workspace=${params.workspace}&conf_code=${params.confCode}`;
  const result = await request.get(url);
  return result.data;
};
// 删除 ai配置
export const delAiConfigApi = async function (id: any) {
  const url = `/AiConfig/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 新增 ai配置
export const saveAiConfigApi = async function (data: any) {
  const url = `/AiConfig/save`;
  const result = await request.post(url, data);
  return result.data;
};
// 修改 ai配置
export const editAiConfigApi = async function (data: any) {
  const url = `/AiConfig/update`;
  const result = await request.post(url, data);
  return result.data;
};
// 获取 空气设备
export const getLoraAirApi = async function (params: any) {
  const url = `/LoraAir/page?current=${params.current}&size=${params.size}&devEUI=${params.devEUI}&sn=${params.sn}&deviceSn=${params.deviceSn}&startTime=${params.startTime}&endTime=${params.endTime}&workspace=${params.workspace}`;
  const result = await request.get(url);
  return result.data;
};
// 获取 幻飞数据
export const getlxAirDataApi = async function (params: any) {
  const url = `/lxAirData/list?page=${params.current}&pageSize=${params.size}&serial=${params.serial}&startTime=${params.startTime}&endTime=${params.endTime}&workspace=${params.workspace}`;
  const result = await request.get(url);
  return result.data;
};
// 获取 多光谱
export const getAeroSpotDataApi = async function (params: any) {
  const url = `/AeroSpotData/page?field=${params.field}&less=${params.less}&greater=${params.greater}&current=${params.current}&size=${params.size}&sn=${params.sn}&startTime=${params.startTime}&endTime=${params.endTime}&workspace=${params.workspace}`;
  const result = await request.get(url);
  return result.data;
};
// 根据sn 获取 多光谱数据
export const getAeroSpotBySnApi = async function (params: any) {
  const url = `/AeroSpotData/tracking?sn=${params.sn}`;
  const result = await request.get(url);
  return result.data;
};
// 推送 图片 （德阳）
export const pushDataApi = async function (params: any) {
  const url = `/dy/send?uavName=${params.uavName}&eventDate=${params.eventDate}&location=${params.location}&resourceName=${params.resourceName}&resourceUrl=${params.resourceUrl}&eventTitle=${params.eventTitle}&eventDesc=${params.eventDesc}&resourceType=${params.resourceType}`;
  const result = await request.get(url);
  return result.data;
};

// ==================== AI离线视频任务管理接口 ====================

// 暂停AI离线视频任务
export const pauseAiVideoTaskApi = async function (id: any) {
  // TODO: 接口待提供
  const url = `/OfflineVideoTask/pause?id=${id}`;
  const result = await request.get(url);
  return result.data;
};

// 启动AI离线视频任务
export const startAiVideoTaskApi = async function (id: any) {
  // TODO: 接口待提供
  const url = `/OfflineVideoTask/start?id=${id}`;
  const result = await request.get(url);
  return result.data;
};

// 删除AI离线视频任务
export const deleteAiVideoTaskApi = async function (id: any) {
  // TODO: 接口待提供
  const url = `/OfflineVideoTask/delete?id=${id}`;
  const result = await request.delete(url);
  return result.data;
};

// 更新AI离线视频任务设置（抽帧间隔、抽帧率）
export const updateAiVideoTaskSettingsApi = async function (data: any) {
  // TODO: 接口待提供
  // data: { id, frame_interval, frame_rate }
  const url = `/OfflineVideoTask/updateSettings`;
  const result = await request.post(url, data);
  return result.data;
};

// ==================== 菜单管理接口 ====================

// 获取菜单列表（使用权限列表接口）
export const getMenuList = async function () {
  const url = `role/getAuthListAll`;
  const result = await request.get(url);
  return result.data;
};

// 新增菜单（权限）
export const menuAddApi = async function (body: any) {
  const url = `Auth/save`;
  const result = await request.post(url, body);
  return result.data;
};

// 修改菜单（权限）
export const menuEditApi = async function (body: any) {
  const url = `Auth/update`;
  const result = await request.post(url, body);
  return result.data;
};

// 删除菜单（权限）
export const menuDel = async function (id: any) {
  const url = `Auth/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};

// 获取短信推送记录
export const getSmsRecordApi = async function (params: any) {
  const url = `AiSmsLog/page?current=${params.current}&size=${params.size}&phone=${params.phone}&type=${params.type}&workspace=${params.workspace}`;
  const result = await request.get(url);
  return result.data;
};
